import { IOrganization } from "@/shared/api/onboarding"

interface OrganizationDataFieldProps {
    label: string
    value: string | null
}

const OrganizationDataField = ({ label, value }: OrganizationDataFieldProps) => (
    <div>
        <label className="font-semibold uppercase text-base text-[#828282] mb-2 block">
            {label}
        </label>
        <div className="text-lg text-color-dark">
            {value || '—'}
        </div>
    </div>
)

interface OrganizationDataProps {
    organization: IOrganization | null
}

export const OrganizationData = ({ organization }: OrganizationDataProps) => {
    return (
        <div className="box">
            <div className="box_header font-mediumttf !mb-4">
                Данные организации
            </div>
            <div className="flex flex-col gap-4">
                <OrganizationDataField label="ИНН" value={organization?.inn || null} />
                <OrganizationDataField label="КПП" value={organization?.kpp || null} />
                <OrganizationDataField label="Наименование" value={organization?.name || null} />
                <OrganizationDataField 
                    label="Полное юридическое наименование" 
                    value={organization?.legal_full_name || null} 
                />
                <OrganizationDataField 
                    label="Юридический адрес" 
                    value={organization?.registration_address || null} 
                />
            </div>
        </div>
    )
}

